module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-900-black-italic-baf3fba82abeba096a446fa101f2da24.woff2";